import { ChangePassword, GetMe, GetCompanyInformation, setLanguage } from '@/api/account.js'
import { useToast } from 'vue-toastification'

const toast = useToast()

const state = () => ({
  passwordType: 'password',
  eyeIcon: 'visibility_off',
  me: {},
  companyInformation: {},
  language: 'sv'
})

// getters
const getters = {}

// actions
const actions = {
  async getMe ({ commit }) {
    const response = await GetMe()
    if (response && response.data && response.data.Customers && Array.isArray(response.data.Customers)) {
      response.data.Customers.sort((a, b) => a.Name.localeCompare(b.Name))
    }

    commit('setMe', response.data)
    let language
    if (response.data.Language === 'Swedish' || response.data.Language === 'Svenska') {
      language = 'sv'
    } else if (response.data.Language === 'English' || response.data.Language.startsWith('Engelsk')) {
      language = 'en'
    } else if (response.data.Language === 'Norwegian' || response.data.Language.startsWith('Norsk')) {
      language = 'no'
    } else if (response.data.Language === 'Danish' || response.data.Language.startsWith('Dansk')) {
      language = 'dk'
    } else {
      language = 'sv'
    }
    commit('setLanguage', language)
  },
  async getCompanyInformation ({ commit }) {
    try {
      const response = await GetCompanyInformation()
      if (response.status === 200) {
        // console.log(response)
        commit('setCompanyInformation', response.data)
      } else {
        // console.log(response)
      }
    } catch (e) {
      // console.log(e)
    }
  },

  toggleShowPassword ({ state, commit }) {
    if (state.passwordType === 'password') {
      commit('setPasswordType', 'text')
      commit('setEyeIcon', 'visibility')
    } else {
      commit('setPasswordType', 'password')
      commit('setEyeIcon', 'visibility_off')
    }
  },
  async handleChangePassword ({ commit }, parameters) {
    if (parameters.password.length < 8 || parameters.repeatPassword.length < 8) {
      toast.error('Password must exceed 7 characters!')
      return
    }
    if (parameters.password === parameters.repeatPassword) {
      const dict = {
        Email: localStorage.getItem('username'),
        NewPassword: parameters.password,
        Token: localStorage.getItem('token')
      }

      try {
        const passwordChangeRespone = await ChangePassword(dict)
        if (passwordChangeRespone.status === 200) {
          toast.success('Password changed!')
          commit('setEyeIcon', 'visibility_off')
        } else {
          toast.error(
            'Password change failed! \r\n\r\n' + passwordChangeRespone.status
          )
        }
      } catch (e) {
        toast.error(
          'Password change failed! \r\n\r\n' + e.message
        )
      }
    } else {
      toast.error('Passwords do not match!')
    }
  },
  async setLanguage ({ commit }, parameter) {
    if (!parameter) {
      return
    }
    const json = {
      Language: parameter
    }
    try {
      const result = await setLanguage(json)
      if (result.status === 200) {
        commit('setLanguage', parameter)
        // dispatch('getTaskById', state.currentTask.Id)
      } else {
        commit('setLanguage', 'sv')
      }
    } catch (e) {
      // console.log(e)
    }
  }
}

const mutations = {
  setPasswordType (state, value) {
    state.passwordType = value
  },
  setEyeIcon (state, value) {
    state.eyeIcon = value
  },
  setMe (state, data) {
    state.me = data
  },
  setCompanyInformation (state, data) {
    state.companyInformation = data
  },
  setLanguage (state, data) {
    state.language = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
